import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const boyIcon: SvgIconData = {
  viewBox: '5.03 5 89.97 90.07',
  element: (
    <path d="M62.1 5v11.8h12.8l-9.3 9.3c-15-10.9-36-9.6-49.4 3.9a38.1 38.1 0 0 0 0 53.9c14.9 14.9 39 14.9 53.9 0A38.2 38.2 0 0 0 74 34.5l9.3-9.3V38H95V5zm-.4 70.5c-10.2 10.2-26.9 10.2-37.2 0s-10.2-26.9 0-37.2a26.44 26.44 0 0 1 37.2 0 26.44 26.44 0 0 1 0 37.2" />
  ),
};
